/* eslint-disable no-param-reassign */
/* eslint-disable prefer-const */
/* eslint-disable camelcase */
import { ElMessage } from 'element-plus';
import { getLocalizedAuthOrLicenseMessage } from '@/js/licenseMessage';

// 傳入一個物件，將物件值為 Null 改為空值
export function objNullToSpace(data) {
  Object.keys(data).forEach((k) => {
    if (data[k] === null) {
      data[k] = '';
    }
  });
  return data;
}

// 傳入一個 data array，將每個 data 值為 Null 改為空值
export function objArryNullToSpace(objArry) {
  let newArry = [];
  objArry.forEach((obj) => {
    let ooo = JSON.parse(JSON.stringify(obj));
    ooo = objNullToSpace(ooo);
    newArry.push(ooo);
  });
  return newArry;
}

export function showMsg(msg, mType, dur) {
  if (msg?.skipError || msg?.response?.skipError) return;

  const rawMsg = msg?.response?.data?.msg || msg?.data?.msg || msg;
  let message = getLocalizedAuthOrLicenseMessage(rawMsg);
  if (!message) {
    if (typeof rawMsg === 'string') {
      message = rawMsg;
    } else {
      try {
        message = JSON.stringify(rawMsg);
      } catch (error) {
        message = String(rawMsg);
      }
    }
  }

  ElMessage({
    showClose: true,
    message,
    type: mType,
    duration: dur,
  });
}

/** 產生Guid */
export function generateNewGuid() {
  const buf = new Uint8Array(16);
  crypto.getRandomValues(buf);

  // version 4
  // eslint-disable-next-line no-bitwise
  buf[6] = (buf[6] & 0x0f) | 0x40;

  // variant
  // eslint-disable-next-line no-bitwise
  buf[8] = (buf[8] & 0x3f) | 0x80;

  const hex = [...buf].map((b) => b.toString(16).padStart(2, '0'));

  const result = [
    hex.slice(0, 4).join(''),
    hex.slice(4, 6).join(''),
    hex.slice(6, 8).join(''),
    hex.slice(8, 10).join(''),
    hex.slice(10, 16).join(''),
  ].join('-');

  return result;
}

/**
 * 數字轉字串並補零
 * @param {*} num
 * @returns
 */
export function numberToString(num) {
  return num.toString().padStart(2, '0');
}

/** 取得現在的時間，固定格式：YYYY-MM-DD HH:mm:ss */
export function getNowTime() {
  const yearStr = new Date().getFullYear();
  const monthStr = (new Date().getMonth() + 1).toString().padStart(2, '0');
  const dayStr = new Date().getDate().toString().padStart(2, '0');
  const hourStr = new Date().getHours().toString().padStart(2, '0');
  const minuteStr = new Date().getMinutes().toString().padStart(2, '0');
  const secondStr = new Date().getSeconds().toString().padStart(2, '0');

  const result = `${yearStr}-${monthStr}-${dayStr} ${hourStr}:${minuteStr}:${secondStr}`;
  return result;
}

/**
 * 兩位數補0
 * @param {*} value
 * @returns
 */
export function pad2(value) {
  return value.toString().padStart(2, '0');
}
